import type { StateUpdater } from '../../../canvas/core';
import type { PageId } from '../../core';
import type { CanvasRendererFn, PageCanvasOverlaySlice } from './types';

export const registerRenderer =
  <Root extends PageCanvasOverlaySlice>(
    pageId: PageId,
    id: string,
    render: CanvasRendererFn
  ): StateUpdater<Root> =>
  state => ({
    ...state,
    pageCanvasOverlay: {
      ...state.pageCanvasOverlay,
      state: {
        renderers: {
          ...state.pageCanvasOverlay.state.renderers,
          [pageId]: [
            ...(state.pageCanvasOverlay.state.renderers[pageId] || []).filter(
              r => r.id !== id
            ),
            { id, render },
          ],
        },
      },
    },
  });

export const unregisterRenderer =
  <Root extends PageCanvasOverlaySlice>(
    pageId: PageId,
    id: string
  ): StateUpdater<Root> =>
  state => ({
    ...state,
    pageCanvasOverlay: {
      ...state.pageCanvasOverlay,
      state: {
        renderers: {
          ...state.pageCanvasOverlay.state.renderers,
          [pageId]: (
            state.pageCanvasOverlay.state.renderers[pageId] || []
          ).filter(r => r.id !== id),
        },
      },
    },
  });
